import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=345456a8&scoped=true&"
import script from "./Alert.vue?vue&type=script&setup=true&lang=js&"
export * from "./Alert.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345456a8",
  null
  
)

/* custom blocks */
import block0 from "./Alert.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
